// @flow
import React, { Component } from 'react';
import _, { get } from 'lodash';
import { Button, Divider, Modal } from 'semantic-grab-ui/src';
import SegPWidget from 'segmentation-widget';

import './SegpRule.scss';

type Props = {
  onChange: Function,
  onClose: Function,
  segments: Array,
  appMode: String,
  maxVisible: Number,
  namespace: String,
};

const DEFAULT_NAMESPACE = 'shared';

export default class SegpModal extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    let segments = '';
    if (props.segments.length > 0 && props.appMode !== 'dax') {
      const segmentNames = props.segments.map(s => {
        // each segment might be either just segment name or <namespace>.<segmentName>
        // here we ensure we only take the segment names
        const items = s.split('.');
        if (items.length < 2) {
          return items[0];
        }
        return items[1];
      });
      segments = segmentNames.join(',');
    }
    this.state = {
      segments,
    };
  }

  getSegmentName = (segment: Object) => {
    const appMode = this.props.appMode || '';
    const namespace = segment.namespace;
    if (appMode === 'dax') {
      return Number(segment.properties.segmentID);
    } else if (appMode === 'pax' || (!_.isNil(namespace) && namespace !== DEFAULT_NAMESPACE)) {
      return `${namespace}.${segment.segmentName}`;
    }

    return segment.segmentName;
  };

  handleSelect = (segment: Object) => {
    const segments = this.props.segments || [];
    segments.push(this.getSegmentName(segment));
    this.props.onChange(segments);
  };

  handleRemove = index => {
    const segments = this.props.segments || [];
    segments.splice(index, 1);
    this.props.onChange(segments);
  };

  handleMultipleSelect = segments => {
    const segmentNames = segments.map(segment => this.getSegmentName(segment));
    this.props.onChange(segmentNames);
  };

  render() {
    const { onClose, appMode, namespace } = this.props;
    const segments = this.props.segments || [];
    const isDaxMode = appMode === 'dax';
    return (
      <Modal
        open
        closeOnDimmerClick={false}
      >
        <Modal.Header>Segmentation Platforms</Modal.Header>
        <Modal.Content>
          <div className="segp-widget">
            <SegPWidget
              src={`${window.Grab.config.SEGMENTATION_PLATFORM_URI}/widget`}
              onSelect={isDaxMode ? this.handleSelect : () => {}}
              namespace={namespace}
              appMode={appMode}
              selection={isDaxMode ? 'single' : 'multiple'}
              onSelectionChange={isDaxMode ? () => {} : this.handleMultipleSelect}
              defaultValue={this.state.segments}
              maxVisible={get(this.props, 'maxVisible', 30)}
              enabledSegmentNSFormat
            />
          </div>
          {isDaxMode && (
            <div>
              <div>
                <b>Segment IDs:</b>
              </div>
              <Divider />
              <div>
                {segments.map((segment, index) => (
                  <div key={segment}>
                    <div className="segment-item">
                      <div className="segment-name">{segment}</div>
                      <Button
                        size="small"
                        color="red"
                        onClick={() => this.handleRemove(index)}
                      >
                        Remove
                      </Button>
                    </div>
                    <Divider />
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={onClose}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
